/* Little Women Provisions — tiny, dependency-free storefront script.
   Everything works without JS (plain form posts); this only makes it snappier. */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const body = document.body;

  /* ---------- Cart drawer ---------- */
  const openCart = () => { body.classList.add('cart-open'); const c = document.querySelector('[data-drawer-close]'); c && c.focus(); };
  const closeCart = () => body.classList.remove('cart-open');

  const renderDrawer = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-drawer-inner]');
    const current = document.querySelector('[data-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    const count = fresh ? fresh.getAttribute('data-count') : null;
    if (count !== null) document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count === '0' ? '' : count; el.dataset.count = count; });
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) {
      if (!document.querySelector('[data-drawer-inner]')) return;
      e.preventDefault(); openCart();
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('.drawer-overlay')) closeCart();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* Line quantity changes inside the drawer */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    const line = Number(btn.dataset.line);
    const quantity = Number(btn.dataset.quantity);
    const inner = document.querySelector('[data-drawer-inner]');
    inner && inner.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      renderDrawer(data.sections && data.sections['cart-drawer']);
    } finally {
      const i = document.querySelector('[data-drawer-inner]'); i && i.classList.remove('is-loading');
    }
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !document.querySelector('[data-drawer-inner]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    btn && btn.setAttribute('disabled', '');
    const fd = new FormData(form);
    /* Always trust our own plan picker. Apps (e.g. Appstle's helper) can inject a second,
       empty selling_plan field on product pages, which would silently turn a subscription
       into a one-time purchase. */
    const picked = form.querySelector('.plans input[name="selling_plan"]:checked');
    if (picked) {
      fd.delete('selling_plan');
      if (picked.value) fd.set('selling_plan', picked.value);
    } else {
      const sp = fd.getAll('selling_plan').find((v) => v);
      fd.delete('selling_plan');
      if (sp) fd.set('selling_plan', sp);
    }
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) {
        if (err) { err.textContent = data.description || data.message || 'Couldn’t add that to your cart. Try again.'; err.hidden = false; }
        return;
      }
      renderDrawer(data.sections && data.sections['cart-drawer']);
      openCart();
    } catch (_) {
      form.submit();
    } finally {
      btn && btn.removeAttribute('disabled');
    }
  });

  /* ---------- Plan picker: button label + price ---------- */
  const syncPlan = (form) => {
    const checked = form.querySelector('input[name="selling_plan"]:checked');
    const btnLabel = form.querySelector('[data-submit-label]');
    if (!checked || !btnLabel) return;
    btnLabel.textContent = checked.value ? form.dataset.subLabel : form.dataset.onceLabel;
  };
  document.querySelectorAll('[data-plan-form]').forEach(syncPlan);
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-plan-form]');
    if (form && e.target.name === 'selling_plan') syncPlan(form);
    if (e.target.matches('[data-variant-select]')) {
      const opt = e.target.selectedOptions[0];
      const f = e.target.closest('form');
      const price = f && f.querySelector('[data-once-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      const submit = f && f.querySelector('[type="submit"]');
      if (submit) submit.toggleAttribute('disabled', opt.dataset.available !== 'true');
      const url = new URL(window.location.href); url.searchParams.set('variant', opt.value);
      history.replaceState({}, '', url);
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(step.dataset.step));
    input.value = next;
  });

  /* ---------- Galleries ---------- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('.gallery__track');
    const dots = [...g.querySelectorAll('[data-dot]')];
    const prev = g.querySelector('[data-prev]');
    const next = g.querySelector('[data-next]');
    if (!dots.length) return;
    const index = () => Math.round(track.scrollLeft / track.clientWidth);
    const goTo = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    const sync = () => {
      const i = index();
      dots.forEach((d, n) => { d.classList.toggle('is-active', n === i); d.toggleAttribute('aria-current', n === i); });
      prev.disabled = i === 0;
      next.disabled = i === dots.length - 1;
    };
    prev.addEventListener('click', () => goTo(index() - 1));
    next.addEventListener('click', () => goTo(index() + 1));
    dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.dot))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
    });
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    sync();
  });

  /* ---------- Sticky buy bar (phones) ---------- */
  document.querySelectorAll('[data-buybar]').forEach((bar) => {
    const form = bar.closest('section').querySelector('[data-plan-form]');
    const card = form && form.closest('.plan-card');
    if (!card) { bar.remove(); return; }
    const btn = bar.querySelector('[data-buybar-btn]');
    const sync = () => setTimeout(() => {
      const r = form.querySelector('input[name="selling_plan"]:checked');
      const price = r ? r.closest('.plan').querySelector('.plan__price') : form.querySelector('[data-once-price]');
      const kicker = r ? r.closest('.plan').querySelector('.plan__kicker') : null;
      bar.querySelector('[data-buybar-price]').textContent = (price ? price.textContent.trim() : '') + (kicker ? ' · ' + kicker.textContent.trim() : '');
      const label = form.querySelector('[data-submit-label]');
      if (label) btn.textContent = label.textContent;
      btn.disabled = form.querySelector('[type="submit"]').disabled;
    }, 0);
    sync();
    form.addEventListener('change', sync);
    btn.addEventListener('click', () => form.requestSubmit());
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
    }).observe(card);
  });
})();
